import {ChangeDetectionStrategy, Component, Input} from "@angular/core";
import {ContactPerson} from "../../../../store/state/order.state";
import {ChangeSet} from "../../history/order-history.model";

@Component({
    selector: 'contact-person-details',
    templateUrl: './contact-person-details.template.html',
    styleUrls: ['./contact-person-details.style.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class ContactPersonDetailsComponent {

	@Input() contactPerson: ContactPerson;
	@Input() changeSet: ChangeSet;	// optional
	@Input() isBillingContact = false;

	get contactPersonDetails(): string {
		return this.contactPerson.firstName + " " + this.contactPerson.lastName;
	}

	get jobTitle(): string {
		return this.contactPerson.jobTitle;
	}

	get phoneNumber(): string {
		let contact = this.contactPerson;
		if (contact.phoneNumber == null) {
			return '';
		}

		return contact.countryCode + ' ' + contact.phoneNumber
	}

	get email(): string {
		return this.contactPerson.email;
	}

	get salesperson(): string {
		return this.contactPerson.salesperson;
	}

	isContactPersonChanged(): boolean {
		return !!this.changeSet && [this.changeSet.changes.contactPerson.firstName, this.changeSet.changes.contactPerson.lastName,
			this.changeSet.changes.contactPerson.jobTitle, this.changeSet.changes.contactPerson.email, this.changeSet.changes.contactPerson.phoneNumber].some(val => !!val);
	}

	isSalespersonChanged(): boolean {
		return !!this.changeSet && [this.changeSet.changes.contactPerson.salesperson].some(val => !!val);
	}
}
